var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71,8.29l-.71-.29V3h-2v5l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v7h2v-7l.71-.29,1-1,.29-.71v-2l-.29-.71-1-1Zm-.71,3.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Zm7.71,2.71l-.71-.29V3h-2V14l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v1h2v-1l.71-.29,1-1,.29-.71v-2l-.29-.71-1-1Zm-.71,3.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17ZM21.71,5.29l-1-1-.71-.29v-1h-2v1l-.71,.29-1,1-.29,.71v2l.29,.71,1,1,.71,.29v11h2V10l.71-.29,1-1,.29-.71v-2l-.29-.71Zm-1.71,2.29l-.41,.41h-1.17l-.41-.41v-1.17l.41-.41h1.17l.41,.41v1.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/1765983986/media/icon-settings.2da55bc48dcd4a81879a4f7b987cc66a.svg";
export { ForwardRef as ReactComponent };